@import "tailwindcss";

/*
  Warm coffee palette + friendly rounded type for Bean Counter Cafe.
  Tailwind v4 reads these CSS variables and generates utilities
  (e.g. `bg-cream`, `text-espresso`, `bg-accent`).
*/
@theme {
  --color-cream: #f9f4ec;
  --color-cream-50: #fdfbf7;
  --color-cream-100: #f4ebdd;
  --color-cream-200: #e9dac4;

  --color-espresso: #2c1a10;
  --color-espresso-soft: #4a3324;
  --color-mocha: #6f4e37;
  --color-latte: #b08d6a;
  --color-foam: #cdb59a;

  --color-accent: #c2702c;
  --color-accent-dark: #a1591f;
  --color-accent-soft: #f3dcc4;

  --color-open: #2f7d4f;
  --color-closed: #9a3b2e;

  --font-sans: "SF Pro Rounded", ui-rounded, "Hiragino Maru Gothic ProN",
    "Quicksand", "Nunito", system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  --radius-card: 1.25rem;
}

@layer base {
  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: var(--color-cream);
    color: var(--color-espresso);
    font-family: var(--font-sans);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  /* Visible focus ring for keyboard users (WCAG AA). */
  :focus-visible {
    outline: 3px solid var(--color-accent-dark);
    outline-offset: 2px;
    border-radius: 0.25rem;
  }

  /* Respect users who prefer reduced motion. */
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
    }
  }
}

/* Skip-link: visible only when focused. */
.skip-link {
  position: absolute;
  left: 0.75rem;
  top: -3rem;
  z-index: 60;
  background-color: var(--color-espresso);
  color: var(--color-cream);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  transition: top 0.15s ease-in-out;
}
.skip-link:focus {
  top: 0.75rem;
}
